import React from 'react';

import { ModalsContext } from 'src/providers/ModalsProvider';

export const useModalsContext = () => {
  return React.use(ModalsContext);
};
